import React from 'react';

import FourZeroFour from '../fourzerofour';
import LinkRender from './LinkRender';

const SearchResults = (props) => {
    const data = props.results;

    if (data && data !== "failed") {
        return (
            <div id="resultCount">
                {
                    data.map((_item, _index) => (<LinkRender searcharea={props.searcharea} link={_item} />))
                }
            </div>
        )
    }

    if (data === "failed")
        return (
            <FourZeroFour />
        )
    return null;
}

export default SearchResults;

